import { useMemo } from "react"
import { useSelector } from "react-redux"

const useActiveGuide = () => {
  const { active, account_status } = useSelector((state) => state.user?.guide) || {}
  const isSelfDeactive = useMemo(() => account_status === "deactivated", [account_status])
  return [active && !isSelfDeactive]
}

export default useActiveGuide
